import { useState } from 'react'
import { motion } from 'framer-motion'

export default function How() {
  const [easterEgg, setEasterEgg] = useState(false)

  return (
    <>
      <div className="flex justify-between -ml-[2rem]">
        <motion.div
          className="flex items-center space-x-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <div className="digit scale-x-125 scale-y-75 skew-x-[-15deg]">1)</div>
          <div className="info max-w-[90%]">
            Гость сканирует QR-код и попадает в бота
          </div>
        </motion.div>

        <motion.div
          className="flex items-center space-x-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          <div className="digit scale-x-75 skew-x-[-15deg]">2)</div>
          <div className="info max-w-[90%]">
            Каждый регистрируется и даст согласие боту
          </div>
        </motion.div>
      </div>

      <div className="flex justify-between -ml-[2rem]">
        <motion.div
          className="flex items-center space-x-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.5 }}
        >
          <div className="digit scale-x-75 scale-y-150 skew-x-[-10deg]">3)</div>
          <div className="info max-w-[100%]">
            Фотограф моментально вам лида добавит
          </div>
        </motion.div>

        <motion.div
          className="flex items-center space-x-2 cursor-pointer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 0.5 }}
          onClick={() => setEasterEgg(!easterEgg)}
        >
          <div className="digit scale-x-150 skew-x-[-15deg]">4)</div>
          <div className="info max-w-[100%]">
            {easterEgg
              ? 'Бот теплому лиду с события снимки отправит'
              : 'Бот теплому лиду отправит с события все снимки'}
          </div>
        </motion.div>
      </div>
    </>
  )
}
